export default "__VITE_ASSET__CymK6BtZ__"